import { Theme, darken } from '@mui/material';
import { Grade } from './enums';

export const getGradeColor = (grade: Grade | null, theme: Theme): string => {
    switch (grade) {
        case Grade.A:
            return theme.palette.success.main;
        case Grade.B:
            return theme.palette.success.light;
        case Grade.C:
            return theme.palette.warning.dark;
        case Grade.D:
            return theme.palette.error.light;
        case Grade.E:
            return theme.palette.error.dark;
        default:
            return theme.palette.text.secondary;
    }
};

export const getGradeStrokeColor = (grade: Grade | null, theme: Theme): string => {
    switch (grade) {
        case Grade.A:
            return theme.palette.success.dark;
        case Grade.B:
            return theme.palette.success.main;
        case Grade.C:
            return darken(theme.palette.warning.dark, 0.25);
        case Grade.D:
            return theme.palette.error.main;
        case Grade.E:
            return darken(theme.palette.error.dark, 0.25);
        default:
            return theme.palette.text.secondary;
    }
};
